module.exports = __webpack_public_path__ + "img/thumbnail3.png";